import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WinService {

  public outerWidth: any = 0;

  constructor() {
    this.outerWidth = window.outerWidth;
  }

  /**
   * return boolean 
   * if the given width is greater than or equals to 
   * window outer width
   * @param width 
   */
  isWidth(width: number){
    if(width >= window.outerWidth){
      return true;
    } else {
      return false;
    }
  }

  get win(){
    return window;
  }

  get getPadding(){
    if(!this.isWidth(768)){
      return '';
    } else {
      return 'pl-30 pr-30';
    }
  }

  /**
   * return boolean if the browser get into mobile screen or large screen
   */
  get isMobile(){
    if(window.outerWidth <= 767){
      return true;
    } else {
      return false;
    }
  }
}
